<template>
  <section class="latest-shipments">
    <div class="latest-shipments-inner">
      <h2 class="shipments-title">Latest shipments</h2>
      <div class="shipments-grid">
        <div v-for="(shipment, index) in displayedShipments" :key="index" class="shipment-item">
          <div class="shipment-header">{{ shipment.part_number }}</div>
          <div class="shipment-info">{{ shipment.description }}</div>
          <div class="shipment-date">{{ formatShipDate(shipment) }}</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'LatestShipments',
  data() {
    return {
      shipments: [],
      loading: false
    }
  },
  mounted() {
    this.fetchShipments()
  },
  computed: {
    displayedShipments() {
      return this.shipments.slice(0, 5)
    }
  },
  methods: {
    async fetchShipments() {
      this.loading = true
      try {
        const res = await this.$api({
          url: 'Content/home',
          method: 'get'
        })
        const latestShipments = (res && res.data && res.data.latest_shipments) || []
        this.shipments = latestShipments
      } catch (err) {
        console.error('Failed to fetch latest shipments:', err)
      } finally {
        this.loading = false
      }
    },
    formatShipDate(shipment) {
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      if (!shipment.ship_date) return ''
      const d = new Date(shipment.ship_date)
      if (isNaN(d.getTime())) return shipment.ship_date
      const formatted = `${months[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`
      const country = shipment.destination_country
      return country ? `${formatted} to ${country}` : formatted
    }
  }
}
</script>

<style scoped>
.latest-shipments {
  width: 100%;
  padding: 0 20px 30px;
  background-color: #fff;
}

.latest-shipments-inner {
  max-width: 1100px;
  margin: 0 auto;
}

.shipments-title {
  margin: 0 0 22px;
  color: #222;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.2;
}

.shipments-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 14px;
}

.shipment-item {
  min-height: 92px;
  padding: 18px 16px 14px;
  border-radius: 4px;
  background-color: #fafafa;
}

.shipment-header {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: inherit;
  font-weight: bold;
  font-size: 16px;
  color: #F34B01;
  line-height: 19px;
}

.shipment-info {
  margin: 9px 0;
}

.shipment-info,
.shipment-date {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: inherit;
  font-weight: 400;
  font-size: 14px;
  color: #747474;
}

@media (max-width: 992px) {
  .shipments-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 768px) {
  .shipments-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 640px) {
  .shipments-grid {
    grid-template-columns: 1fr;
  }
}
</style>
